import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { NoteTypes } from '@/common/constants.ts';
import { API_URL } from '@/dtos';

export const QUERY_KEY_ORG = 'NOTES_BY_ORG_ID';
export const QUERY_KEY_HEALTH_PLAN = 'NOTES_BY_HEALTH_PLAN_ID';
export const QUERY_KEY_PLAN = 'NOTES_BY_PLAN_ID';

type NoteType = NoteTypes.ORG_NOTES | NoteTypes.HEALTH_PLAN_NOTES | NoteTypes.PLAN_NOTES;

const PATHS_MAP = {
  ORG: API_URL.ORGANIZATIONS_NOTES_BY_ORGANIZATION_ID,
  HEALTH_PLAN: API_URL.HEALTH_PLANS_NOTES_BY_ID,
  PLAN: API_URL.PLANS_NOTES_BY_ID,
};

const QUERY_KEYS_MAP = {
  ORG: QUERY_KEY_ORG,
  HEALTH_PLAN: QUERY_KEY_HEALTH_PLAN,
  PLAN: QUERY_KEY_PLAN,
};

export const useGetNotesQuery = (type: NoteType, id?: string, enabled: boolean = true) => {
  const { data, isSuccess, isLoading } = useQuery(
    [QUERY_KEYS_MAP[type], id, enabled],
    () => api.get(PATHS_MAP[type](id || '')),
    {
      enabled: Boolean(id && enabled),
      retry: 0,
    }
  );

  const formattedNotes: string = useMemo(() => {
    if (type === NoteTypes.ORG_NOTES) {
      return toString(data?.data?.text);
    }
    return toString(data?.data);
  }, [data?.data, type]);

  return {
    notes: formattedNotes,
    isLoading,
    isSuccess,
  };
};

export default useGetNotesQuery;
